//== public init for the service charges calculator package
//== reads window.calculatorData.serviceCharges, builds the store, mounts behaviours.
//== auto-runs on DOMContentLoaded; also exported for tests / manual boot.

import { createStore } from './state.js'
import { initInputs } from './inputs.js'
import { initRender } from './render.js'

//== root hook - always scoped, never a bare class (docs/new-calculators.md §5).
//== no legacy fallback: there is no handed-off markup for this calculator, and
//== a bare .wrapper-calc-ui hook is what the redemption retrofit moved away from.
const ROOT_SELECTOR = '.wrapper-calc-ui[data-calc="service-charges"]'

export function initServiceChargesCalculator() {
  const root = document.querySelector(ROOT_SELECTOR)
  if (!root) return null

  //== nested under the existing CMS object so the redemption calculator's
  //== window.calculatorData.scheme contract is untouched. if the key is absent
  //== the calculator runs on DEFAULT_BANDS in calculate.js - the back-end team
  //== should always populate it in production, since the rates change over
  //== time; the defaults exist as a safety net, not as the source of truth.
  const data = (typeof window !== 'undefined' && window.calculatorData) || null
  const config = data?.serviceCharges ?? {}
  const store = createStore({ config })

  initInputs(store, root)
  initRender(store, root, config)

  return { store }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServiceChargesCalculator, { once: true })
  } else {
    initServiceChargesCalculator()
  }
}
